// src/utils/totalsEngine.js — GENERATED from functions/utils/totalsEngine.js. DO NOT EDIT BY HAND.
// Regenerate: node functions/scripts/buildWebTotalsEngine.js   (doced-8f3a61c2)
// src/utils/totalsEngine.test.js fails if this file is not exactly what the generator writes.
// What the engine does and why: see the header of functions/utils/totalsEngine.js.

/* eslint-disable */

// TOTALSENGINE-BODY-START
var TOTALS_ENGINE_VERSION = 1;
var EXEMPTION_KINDS = ['gst', 'pst', 'all'];

// ── cents ───────────────────────────────────────────────────────────────────────────────────

/** Half away from zero, to the cent. toPrecision(15) strips float noise (1.005 → 1.01, not 1.00). */
function toCents(dollars) {
  var n = Number(dollars);
  if (!Number.isFinite(n)) return 0;
  var scaled = Number((Math.abs(n) * 100).toPrecision(15));
  var c = Math.floor(scaled + 0.5);
  return n < 0 ? -c : c;
}
function fromCents(cents) { return cents / 100; }

/** round(cents × pct / 100), exact: pct is scaled to 4 decimals and divided as integers. */
function centsTimesPercent(cents, pct) {
  var p = Math.round(Number(pct) * 10000);
  if (!Number.isFinite(p) || !cents || !p) return 0;
  var num = Math.abs(cents) * Math.abs(p);
  var q = Math.floor(num / 1000000);
  var r = num - q * 1000000;
  if (r * 2 >= 1000000) q += 1;
  return (cents < 0) !== (p < 0) ? -q : q;
}

/** Spread `cents` over non-negative integer weights pro-rata, largest remainder: the parts sum exactly. */
function spreadCentsByWeight(cents, weights) {
  var w = weights.map(function (x) { return x > 0 ? x : 0; });
  var totalW = w.reduce(function (a, b) { return a + b; }, 0);
  if (!w.length || totalW <= 0 || cents <= 0) return w.map(function () { return 0; });
  var raw = w.map(function (x) { return (cents * x) / totalW; });
  var out = raw.map(Math.floor);
  var left = cents - out.reduce(function (a, b) { return a + b; }, 0);
  var order = raw.map(function (v, i) { return [v - Math.floor(v), i]; })
    .sort(function (a, b) { return b[0] - a[0] || a[1] - b[1]; });
  for (var k = 0; k < order.length && left > 0; k++, left--) out[order[k][1]] += 1;
  return out;
}

var num0 = function (v) { var n = Number(v); return Number.isFinite(n) ? n : 0; };

// ── tax parts and kinds ─────────────────────────────────────────────────────────────────────

/**
 * What kind of tax a part is, from its name: 'gst' | 'pst' | 'hst' | 'qst' | 'unknown'.
 * A name naming GST together with a provincial tax is ONE combined part that can't be split → unknown.
 */
function taxPartKind(name) {
  var s = String(name || '').toUpperCase();
  var has = function (w) { return new RegExp('(^|[^A-Z])' + w + '([^A-Z]|$)').test(s); };
  var gst = has('GST') || has('TPS');
  var prov = has('PST') || has('RST') || has('QST') || has('TVQ');
  if (has('HST') || has('TVH')) return 'hst';
  if (gst && prov) return 'unknown';
  if (has('QST') || has('TVQ')) return 'qst';
  if (has('PST') || has('RST')) return 'pst';
  if (gst) return 'gst';
  return 'unknown';
}

/**
 * QuickBooks' raw TaxCode + TaxRate lists → codes with their parts kept (the mapping options
 * callable sums them into one rate and throws the split away). Pure.
 * → [{ Id, Name, components: [{ key, name, rate, kind }] }]
 */
function qbCodeComponents(taxCodes, taxRates) {
  var rates = Array.isArray(taxRates) ? taxRates : [];
  return (Array.isArray(taxCodes) ? taxCodes : []).map(function (code) {
    var details = (code && code.SalesTaxRateList && code.SalesTaxRateList.TaxRateDetail) || [];
    var components = [];
    details.forEach(function (d) {
      var rateId = d && d.TaxRateRef && d.TaxRateRef.value;
      var r = rates.find(function (x) { return String(x.Id) === String(rateId); });
      if (r && Number.isFinite(Number(r.RateValue))) {
        components.push({ key: 'qbrate:' + r.Id, name: r.Name || ('Rate ' + r.Id), rate: Number(r.RateValue), kind: taxPartKind(r.Name) });
      }
    });
    return { Id: String(code.Id), Name: code.Name || '', components: components };
  });
}

function codeRate(code) {
  return (code.components || []).reduce(function (s, c) { return s + num0(c.rate); }, 0);
}
function sameRate(a, b) { return Math.round(num0(a) * 10000) === Math.round(num0(b) * 10000); }

// ── the lookup step ────────────────────────────────────────────────────────────────────────
// A lookup is (line) → null (not mine, try the next) | { code } | { unresolved: reason }.
// A code is { key, name, source, components: [{ key, name, rate, kind }] }.

function legacyCode(rate) {
  var r = num0(rate);
  return { key: 'legacy@' + r, name: 'Tax (' + r + '%)', source: 'companyRate', components: [{ key: 'legacy@' + r, name: 'Tax (' + r + '%)', rate: r, kind: 'unknown' }] };
}
function qbCode(c) {
  return { key: 'qb:' + c.Id, name: c.Name, source: 'quickbooks', components: c.components };
}

/** A real stored tax: a non-blank name or a non-zero rate (the old completeJob { name:'', rate:0 } is not one). */
function hasRealSnapshot(line) {
  var s = line && line.taxSnapshot;
  if (!s || !Number.isFinite(Number(s.rate))) return false;
  return String(s.name || '').trim() !== '' || Number(s.rate) !== 0;
}

/**
 * The Phase 0 lookups, in order. `qbTaxCodes` is the output of qbCodeComponents, [] for a company
 * that is not on QuickBooks, or null when the company IS on QuickBooks but its codes were not loaded
 * (then a coded line is reported unresolved, not guessed).
 */
function phase0Lookups(opts) {
  var o = opts || {};
  var codes = o.qbTaxCodes === undefined ? [] : o.qbTaxCodes;
  var findCode = function (id) { return codes ? codes.find(function (c) { return String(c.Id) === String(id); }) : null; };
  var defaultId = o.qbDefaultTaxCodeId !== undefined && o.qbDefaultTaxCodeId !== null ? String(o.qbDefaultTaxCodeId).trim() : '';
  return [
    function storedTax(line) {
      if (!hasRealSnapshot(line)) return null;
      var s = line.taxSnapshot;
      if (Array.isArray(s.components) && s.components.length) {
        return { code: { key: 'snap:' + (s.rateId || s.name) + '@' + s.rate, name: s.name || '', source: 'snapshot', components: s.components.map(function (c, i) {
          return { key: c.key || ('snap:' + (c.name || i) + '@' + c.rate), name: c.name || '', rate: num0(c.rate), kind: c.kind || taxPartKind(c.name) };
        }) } };
      }
      // The same QuickBooks code at the same rate → use its parts (kinds + per-part rounding).
      var c = line.taxCodeId ? findCode(line.taxCodeId) : null;
      if (c && c.components.length && sameRate(codeRate(c), s.rate)) return { code: qbCode(c) };
      var name = String(s.name || '').trim() || ('Tax (' + num0(s.rate) + '%)');
      return { code: { key: 'snap:' + name + '@' + num0(s.rate), name: name, source: 'snapshot', components: [{ key: 'snap:' + name + '@' + num0(s.rate), name: name, rate: num0(s.rate), kind: taxPartKind(name) }] } };
    },
    function quickBooksLineCode(line) {
      if (!line.taxCodeId) return null;
      if (codes === null) return { unresolved: 'qbCodesNotLoaded' };
      var c = findCode(line.taxCodeId);
      return c ? { code: qbCode(c) } : null; // a code QuickBooks no longer has falls through, as the editors do
    },
    function quickBooksDefaultCode(line) {
      if (line.taxCodeId || !defaultId) return null;
      if (codes === null) return { unresolved: 'qbCodesNotLoaded' };
      var c = findCode(defaultId);
      return c ? { code: qbCode(c) } : null;
    },
    function companyRate() {
      return { code: legacyCode(o.legacyRate) };
    },
  ];
}

// taxlines-771ce983 — Settings › Taxes (named) codes. A part is keyed by its NAME + RATE, not by the
// code it sits in, so "GST 5%" on a "GST + PST" line and on a "GST" line add into ONE row and are
// rounded once (the same rule as lineTax.taxPartKey; testTotalsEngine checks the two agree).
function normPartName(name) {
  return String(name === null || name === undefined ? '' : name).trim().replace(/\s+/g, ' ').toLowerCase();
}
function namedPartKey(name, rate) {
  var n = Number(rate);
  return 'part:' + normPartName(name) + '@' + (Number.isFinite(n) ? String(Math.round(n * 1000) / 1000) : '0');
}
function namedCode(id, name, parts) {
  return { key: 'named@' + id, name: String(name || ''), source: 'named', components: parts.map(function (p) {
    return { key: namedPartKey(p && p.name, p && p.rate), name: String((p && p.name) || ''), rate: num0(p && p.rate), kind: taxPartKind(p && p.name) };
  }) };
}

/**
 * The lookups for a company with Settings › Taxes ON. opts.namedCodes = settings/taxCodes `codes`.
 * Order: the line's own named code (its kept copy, salesTaxSnapshot, when it is for that code; else
 * the code as it is now) → the Phase 0 stored tax / QuickBooks steps (inert without QuickBooks) →
 * the company's default named code → the single company rate. A company with Settings › Taxes OFF
 * keeps using phase0Lookups, so nothing it computes can change.
 */
function namedTaxLookups(opts) {
  var o = opts || {};
  var codes = Array.isArray(o.namedCodes) ? o.namedCodes : [];
  var usable = function (c) { return c && typeof c.id === 'string' && c.id !== '' && Array.isArray(c.parts) && c.parts.length > 0; };
  var byId = function (id) { return codes.find(function (c) { return usable(c) && c.id === id; }) || null; };
  var base = phase0Lookups(o);
  return [
    function namedLineCode(line) {
      var id = typeof line.salesTaxCodeId === 'string' ? line.salesTaxCodeId : '';
      if (!id) return null;
      var s = line.salesTaxSnapshot;
      if (s && s.codeId === id && Array.isArray(s.parts) && s.parts.length) return { code: namedCode(id, s.name, s.parts) };
      var c = byId(id);
      return c ? { code: namedCode(c.id, c.name, c.parts) } : { unresolved: 'namedCodeMissing' };
    },
    base[0], base[1], base[2],
    function namedDefaultCode() {
      var d = codes.find(function (c) { return usable(c) && c.isDefault === true && c.stopped !== true; });
      return d ? { code: namedCode(d.id, d.name, d.parts) } : null;
    },
    base[3],
  ];
}

/** Chain lookups into one resolver: (line) → { code, unresolved }. The last lookup must always answer. */
function makeTaxCodeResolver(lookups) {
  return function (line) {
    var unresolved = null;
    for (var i = 0; i < lookups.length; i++) {
      var r = lookups[i](line || {});
      if (!r) continue;
      if (r.unresolved) { unresolved = unresolved || r.unresolved; continue; }
      return { code: r.code, unresolved: unresolved };
    }
    return { code: legacyCode(0), unresolved: unresolved || 'noLookupAnswered' };
  };
}

// ── discounts ─────────────────────────────────────────────────────────────────────────────

/** A discount { type: 'amount' | 'percent', value } on a base, in cents, never more than the base, never below 0. */
function discountCents(discount, baseCents) {
  if (!discount || baseCents <= 0) return 0;
  var v = num0(discount.value);
  if (v <= 0) return 0;
  var d = discount.type === 'percent' ? centsTimesPercent(baseCents, Math.min(v, 100)) : toCents(v);
  return Math.max(0, Math.min(d, baseCents));
}

// ── exemption ─────────────────────────────────────────────────────────────────────────────

// taxlines-771ce983 — `parts` (optional): the names of the company's own tax parts the customer is
// exempt from, e.g. ['PST']. Matched by name, ignoring capitals and spaces, on every line whatever
// its code. Without `parts` the answer is exactly as before.
function normaliseExemption(ex) {
  var kinds = ex && Array.isArray(ex.kinds) ? ex.kinds.filter(function (k) { return EXEMPTION_KINDS.indexOf(k) !== -1; }) : [];
  var parts = ex && Array.isArray(ex.parts) ? ex.parts.map(normPartName).filter(Boolean) : [];
  if (!kinds.length && !parts.length) return null;
  var out = { kinds: kinds, number: (ex && ex.number) || '' };
  if (parts.length) out.parts = parts;
  return out;
}
function exemptionSwitchedOff(doc) {
  var off = doc && doc.taxExemptionOff;
  return !!(off && String(off.by || '').trim() && off.at && String(off.reason || '').trim());
}

// ── the engine ────────────────────────────────────────────────────────────────────────────

/**
 * computeDocumentTotals(doc, ctx)
 *   doc  { lineItems: [{ quantity, price, taxExempt, taxCodeId, taxSnapshot, salesTaxCodeId, salesTaxSnapshot, discount, itemId, lineId }],
 *          discount?: { type, value }, taxExemptionOff?: { by, at, reason } }
 *   ctx  { resolveTaxCode: (line) → { code, unresolved },   (makeTaxCodeResolver(phase0Lookups(…)))
 *          customerExemption?: { kinds: ['gst'|'pst'|'all'], parts?: ['PST', …], number },
 *          mode?: 'headline' (every line, default) | 'approved' (only lines in approvedItemIds),
 *          approvedItemIds?: [] }
 * → { engineVersion, subtotal, discountTotal, taxAmount, total, taxParts: [{ key, name, rate, kind,
 *     taxable, amount, exempt? }], lines: [...], notes: [{ code, line?, detail? }], unresolved, cents: {…} }
 *     exempt (taxexempt3-8c4f2a1d): a part the customer is exempt from — its own row, amount 0,
 *     exempt: { number } (the customer's exemption number). Without an exemption no row has it.
 * Dollar figures are exact two-decimal numbers; `cents` holds the same figures as integers.
 */
function computeDocumentTotals(doc, ctx) {
  var d = doc || {};
  var c = ctx || {};
  var resolve = c.resolveTaxCode || makeTaxCodeResolver(phase0Lookups({}));
  var notes = [];
  var all = Array.isArray(d.lineItems) ? d.lineItems : [];
  var approved = c.mode === 'approved' ? new Set(c.approvedItemIds || []) : null;

  // 1. Line amounts and line discounts.
  var lines = [];
  all.forEach(function (item, index) {
    if (!item) return;
    if (approved && !(item.itemId && approved.has(item.itemId))) return;
    var amount = toCents(num0(item.quantity) * num0(item.price));
    var lineDisc = discountCents(item.discount, amount);
    lines.push({ index: index, lineId: item.lineId || null, item: item, amount: amount, discount: lineDisc, net: amount - lineDisc });
  });

  // 2. Document discount, spread over lines with something left, in proportion to what is left.
  var netSum = lines.reduce(function (s, l) { return s + l.net; }, 0);
  var positive = lines.reduce(function (s, l) { return s + (l.net > 0 ? l.net : 0); }, 0);
  var docDisc = Math.min(discountCents(d.discount, Math.max(0, netSum)), positive);
  var shares = spreadCentsByWeight(docDisc, lines.map(function (l) { return l.net > 0 ? l.net : 0; }));
  lines.forEach(function (l, i) { l.docDiscount = shares[i] || 0; l.net -= l.docDiscount; });

  // 3. Tax: the taxable amount of each part across the document; one rounding per part.
  var exemption = normaliseExemption(c.customerExemption);
  if (exemption && exemptionSwitchedOff(d)) { notes.push({ code: 'exemptionSwitchedOff', detail: d.taxExemptionOff.reason }); exemption = null; }
  var exemptAll = !!(exemption && exemption.kinds.indexOf('all') !== -1);
  var parts = {};
  var order = [];
  var unresolved = false;
  lines.forEach(function (l) {
    l.exemptedParts = [];
    if (l.item.taxExempt) { l.taxCodeKey = null; return; }
    var r = resolve(l.item);
    if (r.unresolved) { unresolved = true; notes.push({ code: 'taxCodeUnresolved', line: l.index, detail: r.unresolved }); }
    l.taxCodeKey = r.code.key;
    l.taxSource = r.code.source;
    (r.code.components || []).forEach(function (p) {
      if (exemption) {
        var removable = exemptAll || ((p.kind === 'gst' || p.kind === 'pst') && exemption.kinds.indexOf(p.kind) !== -1)
          || (!!exemption.parts && exemption.parts.indexOf(normPartName(p.name)) !== -1);
        // taxexempt3-8c4f2a1d — an exempted part is kept as its OWN row at $0.00 (slot 'x:' + key), so
        // the customer's documents can say "GST 5% — exempt #…"; it adds nothing to the tax.
        if (removable) {
          l.exemptedParts.push(p.key);
          var xk = 'x:' + p.key;
          if (!parts[xk]) { parts[xk] = { key: p.key, name: p.name, rate: num0(p.rate), kind: p.kind || 'unknown', taxable: 0, exempt: true }; order.push(xk); }
          parts[xk].taxable += l.net;
          return;
        }
        if (exemption.kinds.length) notes.push({ code: 'exemptionNotApplied', line: l.index, detail: p.name + ' (' + p.kind + ')' });
      }
      if (!parts[p.key]) { parts[p.key] = { key: p.key, name: p.name, rate: num0(p.rate), kind: p.kind || 'unknown', taxable: 0 }; order.push(p.key); }
      parts[p.key].taxable += l.net;
    });
  });
  var taxParts = order.map(function (k) {
    var p = parts[k];
    if (p.exempt) return { key: p.key, name: p.name, rate: p.rate, kind: p.kind, taxableCents: p.taxable, amountCents: 0, exempt: true };
    return { key: p.key, name: p.name, rate: p.rate, kind: p.kind, taxableCents: p.taxable, amountCents: centsTimesPercent(p.taxable, p.rate) };
  });

  var subtotal = lines.reduce(function (s, l) { return s + l.amount; }, 0);
  var discountTotal = lines.reduce(function (s, l) { return s + l.discount + l.docDiscount; }, 0);
  var tax = taxParts.reduce(function (s, p) { return s + p.amountCents; }, 0);
  var total = subtotal - discountTotal + tax;

  return {
    engineVersion: TOTALS_ENGINE_VERSION,
    subtotal: fromCents(subtotal),
    discountTotal: fromCents(discountTotal),
    taxAmount: fromCents(tax),
    total: fromCents(total),
    taxParts: taxParts.map(function (p) {
      var out = { key: p.key, name: p.name, rate: p.rate, kind: p.kind, taxable: fromCents(p.taxableCents), amount: fromCents(p.amountCents) };
      if (p.exempt) out.exempt = { number: String(exemption.number || '') }; // taxexempt3-8c4f2a1d
      return out;
    }),
    lines: lines.map(function (l) {
      return { index: l.index, lineId: l.lineId, amount: fromCents(l.amount), discount: fromCents(l.discount + l.docDiscount), net: fromCents(l.net), taxCodeKey: l.taxCodeKey, taxSource: l.taxSource || null, exemptedParts: l.exemptedParts };
    }),
    notes: notes,
    unresolved: unresolved,
    cents: { subtotal: subtotal, discountTotal: discountTotal, taxAmount: tax, total: total, taxParts: taxParts.map(function (p) { return p.exempt ? { key: p.key, taxable: p.taxableCents, amount: 0, exempt: true } : { key: p.key, taxable: p.taxableCents, amount: p.amountCents }; }) },
  };
}
// TOTALSENGINE-BODY-END

export { TOTALS_ENGINE_VERSION, EXEMPTION_KINDS, toCents, fromCents, centsTimesPercent, spreadCentsByWeight, taxPartKind, qbCodeComponents, hasRealSnapshot, phase0Lookups, namedTaxLookups, namedPartKey, makeTaxCodeResolver, discountCents, computeDocumentTotals };
